import React, { useState, useEffect } from 'react'
//import { useHistory } from 'react-router'
import { FormattedMessage } from 'react-intl';
import { Arrow as ArrowRight, ImageAmorimWise, ImageWicanders } from '../../../assets'
import { 
  Container, 
  AmorimWise, 
  Wicanders, 
  ContainerContent, 
  Text,
  BigText,
  Arrow,
  ButtonStartVisit 
} from './index.styled'

function SplashSplitDesktop({ active, handleScreenActive }) {
  //const history = useHistory()
  const [ amorimClass, setAmorimClass ] = useState('');
  const [ wicandersClass, setWicandersClass ] = useState('');

  const handleClickAmorin = () => {
    console.log("click Amorin Wise");
   // history.replace("/wise")
   window.open('https://showroom.amorimwise.com', '_blank')
  }

  const handleClickWicanders = () => {
    //history.replace("/wicanders")
    window.open('https://showroom.wicanders.com', '_blank')
  }

  useEffect(() => {
    switch(active) {
      case 'amorin_wise':
        setAmorimClass('stretch');
        setWicandersClass('shrink');
        break;
      case 'wicanders':
        setWicandersClass('stretch');
        setAmorimClass('shrink');
        break;
      default:
        setAmorimClass('');
        setWicandersClass('');
    }
    if(active === '') {
      setAmorimClass('');
      setWicandersClass('');
    }
  }, [active])

  return (
    <Container>
      <AmorimWise 
        onMouseOver={() => handleScreenActive('amorin_wise')}
        onMouseLeave={() => handleScreenActive('')}
        className={amorimClass}
      >
        <ContainerContent>
          <Text><FormattedMessage id="splash.smart-choice" /></Text>
          <Text><FormattedMessage id="splash.amazing-sensations" /></Text>
          <BigText src={ImageAmorimWise} width={250}/>
          <ButtonStartVisit onClick={handleClickAmorin}>
            <Text><FormattedMessage id="splash.start-visit" /></Text>
            <Arrow background={ArrowRight} />
          </ButtonStartVisit>
        </ContainerContent>
      </AmorimWise>
      <Wicanders 
        onMouseOver={() => handleScreenActive('wicanders')}
        onMouseLeave={() => handleScreenActive('')}
        className={wicandersClass}
        >
        <ContainerContent className="content-right">
          <Text><FormattedMessage id="splash.everyday-confort" /></Text>
          <Text><FormattedMessage id="splash.lifetime-perfomance" /></Text>
          <BigText src={ImageWicanders} width={216} className="pos-right"/>
          <ButtonStartVisit onClick={handleClickWicanders} className="pos-right">
            <Text><FormattedMessage id="splash.start-visit" /></Text>
            <Arrow background={ArrowRight}/>
          </ButtonStartVisit>
        </ContainerContent>
      </Wicanders>
    </Container>
  )
}

export default SplashSplitDesktop;